<template>
  <div class="dropdown" >
    <button v-bind:style="buttonStyle" :class="'btn btn-outline btn-info dropdown-toggle ' + buttonClass" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
      {{value | capitalize}}
      <span class="caret"></span>
    </button>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenu1" style="min-width: 100%">
      <li>
        <a @click="typeChange('science')">
          <span style="padding-left: 13px"></span> Science
        </a>
      </li>
      <li>
        <a @click="typeChange('patents')">
          <i v-if="$user.isBasic()" class="fa fa-lock"></i><span v-else style="padding-left: 13px"></span> Patents
        </a>
      </li>
      <li>
        <a @click="typeChange('company')">
          <i v-if="$user.isBasic()" class="fa fa-lock"></i><span v-else style="padding-left: 13px"></span> Company
        </a>
      </li>
      <li>
        <a @click="typeChange('news')">
          <i v-if="$user.isBasic()" class="fa fa-lock"></i><span v-else style="padding-left: 13px"></span> News
        </a>
      </li>
      <li v-if="!$user.isOrange() && !$user.isSe()">
        <a @click="typeChange('aichat')">
          <i v-if="$user.isBasic()" class="fa fa-lock"></i><span v-else style="padding-left: 13px"></span>  AI Chat <span class="label label-warning"> Beta</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<style>
</style>
<script>
export default {
  name: 'DocumentTypeDropdown',
  props: ['buttonStyle', 'buttonClass', 'value', 'showLimitPlan'],
  methods: {
    typeChange: function (type) {
      if (this.$user.isBasic() && (type === 'company' || type === 'patents' || type === 'news' || type === 'aichat')) {
        this.showLimitPlan()
      } else {
        this.$emit('input', type)
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) {
        return ''
      }
      value = value === 'aichat' ? 'AI Chat (Beta)' : value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/DocumentTypeDropdown.vue